// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ColumnPickerHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0.5rem;
  border-bottom: 1px solid var(--mb-color-border);
  color: var(--mb-color-text-secondary);
`;

export const ColumnPickerHeaderTitleContainer = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
`;
